import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup } from '@angular/forms';

@Injectable()
export class ChangeOrganismoService  {

		constructor(
		private http: HttpClient,
	) {
	}

	getSearch(settings, formGroup: FormGroup) {

		let search = String(formGroup.get('busca').value);
		let campo = String(formGroup.get('campo').value);
		let condition = formGroup.get('condicao').value;

		if (condition === '8' || condition === '9') {
			condition -= 1;
		}

		let property = campo.substr(0, 1).toUpperCase() + campo.substr(1);

		let viewModel = [{
			'property': property,
			'condition': condition,
			'value': search,
		}];

		return this.http.post<any[]>(`${settings.env.apiLoginUrl}v1/organismo/search`, viewModel);
	}

	trocarOrganismo(settings, novoOrganismoId: number, refresh_token: string) {

		let viewModel = 'grant_type=refresh_token&refresh_token=' + refresh_token;

		return this.http.post(`${settings.env.apiLoginUrl}v1/security/token?organismoId=${novoOrganismoId}`, viewModel,
			{ headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });

	}
}

class ConfiguracoesFilter {
	public property: string;
    public value: any;
    public condition: number;
}